"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const serviceAreas = ["Splendora, TX", "New Caney, TX", "Porter, TX", "Cleveland, TX", "Kingwood, TX", "Roman Forest, TX", "Patton Village, TX", "Atascocita, TX", "Humble, TX", "Woodbranch, TX"];
export default function ServingTheAustinMetroArea() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: mapRef
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="131404" id="serving-our-texas-neighbors" className="py-16 text-foreground overflow-hidden !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] !bg-[rgba(255,255,255,1)] md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={mapRef} className="relative w-full aspect-square rounded-2xl overflow-hidden bg-muted border border-border transition-all duration-1000 ease-out opacity-100 translate-x-0 !border-[hsl(0,0%,0%)] border-solid !border-3 !shadow-[0px_36px_72px_rgba(20,21,31,0.5),_0px_18px_36px_rgba(20,21,31,0.30)] md:aspect-[4/3] lg:aspect-square">
            {}
            <div className="absolute inset-8 bg-gradient-to-tr from-background/80 via-background/20 to-transparent bg-no-repeat bg-center bg-cover rounded-xl !border-[hsl(0,0%,0%)] border-solid !border-2 !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] !bg-[url(https://schaefergaragedoors.com/wp-content/uploads/2026/05/660758829_122120368395209682_2818658536071485800_n-e1775081291220-1.jpg)] )]"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out delay-200 ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <h2 className="tracking-tight text-foreground uppercase !font-sans !text-[49px] !font-semibold">
                RELIABLE SERVICE ACROSS KINGWOOD & SURROUNDING AREAS
              </h2>
              <p className="text-lg leading-relaxed max-w-xl !text-[hsl(210,9%,31%)]">
                From Kingwood to Cleveland, Schaefer Garage Doors is your local, veteran-owned partner for professional garage door repairs and installation. We dispatch experienced technicians to ensure fast response times and 24/7 support when you need us the most.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-sm font-semibold text-foreground uppercase tracking-widest">
                Our Local Service Areas
              </h3>
              <div className="flex flex-wrap gap-2 md:gap-3">
                {serviceAreas.map((area, i) => {
                const badgeClasses = "border border-[#1B8439] text-[#1B8439] bg-white hover:bg-[rgba(27,132,57,0.08)] rounded-xl px-6 py-3 font-semibold transition-all duration-300";
                const serviceUrls = ["https://schaefergaragedoors.com/service-areas/garage-door-repair-in-splendora-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-new-caney-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-porter-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-cleveland-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-kingwood-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-roman-forest-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-patton-village-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-atascocita-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-humble-tx/", "https://schaefergaragedoors.com/service-areas/garage-door-repair-in-woodbranch-tx/"];
                return <Link key={i} to={serviceUrls[i] || "#"}>
                  <Badge variant="secondary" className={badgeClasses}>
                    {area}
                  </Badge>
                </Link>;
              })}
              </div>
            </div>

            <div className="pt-4 flex flex-col sm:flex-row gap-4">
              {}
              <Button size="lg" className="bg-primary text-white rounded-md px-4 py-2 font-medium transition-all duration-300" asChild>
                <Link to="https://schaefergaragedoors.com/contact-us/">
                  Check Availability
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              {}
              <Button size="lg" variant="outline" className="bg-primary text-white rounded-md px-4 py-2 font-medium transition-all duration-300" asChild>
                <Link to="#">
                  View All Services
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}